import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import pinkInifityAnim from '../../assets/animations/loader.json';

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    padding-top: 100;
    z-index: 5;
`;

const AnimatedLoader = () => {
    const container = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!container.current) {
            return;
        }
        const animation = lottie.loadAnimation({
            container: container.current,
            animationData: pinkInifityAnim,
            renderer: 'svg',
            loop: true,
            autoplay: true
        });
        return () => animation.destroy();
    }, []);

    return (
        <Wrapper>
            <div ref={container} />
        </Wrapper>
    );
};

export default AnimatedLoader;
